<template>
  <v-container class="admin-event" fluid>
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_hkiarace.event') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               @click="addEventModalShown = true">
          {{ $t('admin_event.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <AdminEventList full-height
                        :refresh-trigger.sync="refreshTrigger"
                        @edit="onEventEdit"></AdminEventList>
      </v-col>
    </v-row>

    <AddEventModal :shown="addEventModalShown"
                   @cancel="addEventModalShown = false"
                   @finish="onAddEventModalFinish"></AddEventModal>

    <EditEventModal :shown="editEventModalShown"
                    :event-id="editingEventId"
                    @cancel="editEventModalShown = false"
                    @finish="onEditEventModalFinish"></EditEventModal>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import AdminEventList from "@/components/event/AdminEventList";
import AddEventModal from "@/components/event/AddEventModal";
import EditEventModal from "@/components/event/EditEventModal";

export default {
  name: 'Event',
  components: {EditEventModal, AddEventModal, AdminEventList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const addEventModalShown = ref(false);
    const onAddEventModalFinish = function (item) {
      addEventModalShown.value = false;
      refresh();
      onEventEdit(item);
    }

    const editingEventId = ref(null);
    const editEventModalShown = ref(false);
    const onEventEdit = function (item) {
      editingEventId.value = item.id;
      editEventModalShown.value = true;
    };
    const onEditEventModalFinish = function () {
      editEventModalShown.value = false;
      refresh();
    }

    return {
      refreshTrigger,
      refresh,

      addEventModalShown,
      onAddEventModalFinish,

      editingEventId,
      editEventModalShown,
      onEventEdit,
      onEditEventModalFinish,
    }
  },
}
</script>

<style lang="less">
.admin-event {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
